import { Link, Typography } from '@mui/material';
import MuiStack from '@mui/material/Stack';
import { RHFCheckbox } from './hook-form';

export const OptInHeader = () => (
  <Typography variant="body2" sx={{ fontWeight: '500' }}>
    By signing up, you agree to Subflow's{' '}
    <Link href="https://www.subflow.com/terms-and-conditions" target="_blank">
      Terms of Service
    </Link>{' '}
    and{' '}
    <Link href="https://www.subflow.com/privacy" target="_blank">
      Privacy Policy
    </Link>
  </Typography>
);

export const OptInHeaderNew = () => (
  <Typography variant="subtitle2">
    Signing up means you agree to our{' '}
    <Link href="https://www.subflow.com/terms-and-conditions" target="_blank">
      Terms
    </Link>{' '}
    and{' '}
    <Link href="https://www.subflow.com/privacy" target="_blank">
      Privacy Policy.
    </Link>
  </Typography>
);

const OptIn = ({ merchantName, platform = false }) => {
  const userDescription = platform
    ? 'the Subflow platform'
    : `${merchantName}, a user of the Subflow platform`;
  return (
    <>
      {' '}
      {!platform && <OptInHeader />}
      <MuiStack spacing={2} pb={2} pt={1}>
        <RHFCheckbox
          name="agreeTerms"
          sx={{ alignItems: 'start' }}
          checkboxStyles={{ paddingTop: 0 }}
          data-testid="opt-in"
          label={
            <Typography variant="caption">
              By selecting, you agree to receive text messages from{' '}
              {userDescription}. Text HELP for help and Text STOP to cancel.
              Message frequency varies and data rates may apply. For more
              information, please review our{' '}
              <Link
                href="https://www.subflow.com/terms-and-conditions"
                target="_blank"
              >
                SMS Terms
              </Link>{' '}
              and{' '}
              <Link href="https://www.subflow.com/privacy" target="_blank">
                Privacy Policy
              </Link>
              .
            </Typography>
          }
        />
      </MuiStack>
    </>
  );
};

export default OptIn;
